"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Magazines;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Magazines(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "magazines"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.674,33.071a7.486,7.486,0,0,0-3.742-6.48C37.774,22.433,20.378,19.7,15.759,20.1a8.483,8.483,0,0,0-8,8.782c0,1.036-.156,23.722-.251,36.934a8.145,8.145,0,0,0,1.828,5.538,8.614,8.614,0,0,0,6.229,3c13.043.99,20.1,3.865,22.434,4.816l.433.176a7.774,7.774,0,0,0,2.881.588,6.248,6.248,0,0,0,3.6-1.12,6.8,6.8,0,0,0,2.764-5.6ZM42.046,74.72a1.808,1.808,0,0,1-1.745-.007l-.428-.174c-2.5-1.018-10.1-4.117-23.931-5.165a3.761,3.761,0,0,1-2.758-1.212,3.132,3.132,0,0,1-.68-2.118c0-.044,0-.088.005-.132.084-11.694.251-35.912.25-37.1a3.59,3.59,0,0,1,3.435-3.727c.2-.018.448-.026.725-.026,4.739,0,19.59,2.536,24.227,5.686l.048.032a2.625,2.625,0,0,1,1.48,2.238V73.289A1.9,1.9,0,0,1,42.046,74.72Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.491,65.818c-.1-14.193-.246-35.551-.248-36.9a8.508,8.508,0,0,0-8-8.813c-4.63-.4-22.048,2.323-28.107,6.445a7.545,7.545,0,0,0-3.808,6.461V73.08a6.829,6.829,0,0,0,2.766,5.74,6.238,6.238,0,0,0,3.593,1.119,7.8,7.8,0,0,0,2.892-.593l.436-.177c2.319-.945,9.377-3.82,22.418-4.809a8.606,8.606,0,0,0,6.234-3.007A8.149,8.149,0,0,0,92.491,65.818Zm-5.677,2.346a3.75,3.75,0,0,1-2.758,1.21c-13.826,1.048-21.43,4.147-23.937,5.168l-.406.165a1.791,1.791,0,0,1-1.757.014,1.989,1.989,0,0,1-.63-1.577V32.96c-.007-.364.128-1.309,1.574-2.247,4.611-3.136,19.434-5.656,24.177-5.656.279,0,.525.008.73.026a3.6,3.6,0,0,1,3.438,3.73c0,.024,0,.047,0,.071,0,1.143.179,27.116.248,37.028,0,.044,0,.088,0,.132A3.13,3.13,0,0,1,86.814,68.164Z"
  })))));
}